import { FloorGameTicksMeterSize } from './types';

export const tokens = {
    meterSize: {
        [FloorGameTicksMeterSize.Compact]: 10,
        [FloorGameTicksMeterSize.Normal]: 12,
        [FloorGameTicksMeterSize.Extended]: 19,
    },
};
